var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#4E443D",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 25.6 25.6 25.6 25.6 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.4 25.6 64 25.6 64 0 38.4 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 64 25.6 64 25.6 38.4 0 38.4"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4E443D",
    points: "9.6 54.4 16 54.4 16 48 9.6 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4E443D",
    points: "9.6 16 16 16 16 9.6 9.6 9.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4E443D",
    points: "48 16 54.4 16 54.4 9.6 48 9.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4E443D",
    points: "48 54.4 54.4 54.4 54.4 48 48 48"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#4E443D",
    strokeLinecap: "square",
    strokeWidth: 6,
    transform: "translate(38.4 38.4)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "0 12.8 0 25.6 25.6 25.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "0 0 25.6 0 25.6 12.8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.5b32d4e1d23263a63a4510b188b2c54e.svg";
export { ForwardRef as ReactComponent };